webpackJsonp([242681201964820],{

/***/ 85:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(9);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _gatsbyLink = __webpack_require__(8);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ObjectGrid = function (_React$Component) {
	  _inherits(ObjectGrid, _React$Component);
	
	  function ObjectGrid(props) {
	    _classCallCheck(this, ObjectGrid);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	    _this.state = { objectdata: [] };
	    return _this;
	  }
	
	  ObjectGrid.prototype.componentDidMount = function componentDidMount() {
	    var _this2 = this;
	
	    //get the object data
	    var objid = this.props.objectid;
	    fetch('https://data.artmuseum.princeton.edu/objects/' + objid).then(function (res) {
	      return res.json();
	    }).then(function (objectdata) {
	      return _this2.setState({ objectdata: objectdata });
	    });
	  };
	
	  ObjectGrid.prototype.render = function render() {
	    var date = void 0;
	    if (this.state.objectdata.displaydate) {
	      date = ', ' + this.state.objectdata.displaydate;
	    }
	
	    return _react2.default.createElement(
	      'div',
	      { className: 'object-grid' },
	      _react2.default.createElement(
	        _gatsbyLink2.default,
	        { to: '/objects/' + this.props.objectid },
	        _react2.default.createElement(
	          'div',
	          { className: 'object-grid__thumbnail' },
	          _react2.default.createElement('img', {
	            src: this.state.objectdata.primaryimage + '/full/!150,150/0/default.jpg'
	          })
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'object-grid__tombstone' },
	          _react2.default.createElement(
	            'div',
	            null,
	            this.state.objectdata.displayperiod
	          ),
	          _react2.default.createElement(
	            'div',
	            null,
	            this.state.objectdata.displaymaker
	          ),
	          _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(
	              'strong',
	              null,
	              this.state.objectdata.displaytitle
	            ),
	            date
	          )
	        )
	      )
	    );
	  };
	
	  return ObjectGrid;
	}(_react2.default.Component);
	
	exports.default = ObjectGrid;
	module.exports = exports['default'];

/***/ }),

/***/ 86:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(9);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var SearchBar = function (_React$Component) {
	  _inherits(SearchBar, _React$Component);
	
	  function SearchBar(props) {
	    _classCallCheck(this, SearchBar);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	    _this.state = { value: '' };
	
	    _this.handleChange = _this.handleChange.bind(_this);
	    _this.handleSubmit = _this.handleSubmit.bind(_this);
	    return _this;
	  }
	
	  SearchBar.prototype.handleChange = function handleChange(event) {
	    this.setState({ value: event.target.value });
	  };
	
	  SearchBar.prototype.handleSubmit = function handleSubmit(event) {
	    event.preventDefault();
	    window.location.href = 'https://artmuseum.princeton.edu/search/collections?mainSearch="' + this.state.value + '"&cultureList=["' + this.props.culture + '"]';
	  };
	
	  SearchBar.prototype.render = function render() {
	    if (this.props.culture) {
	      return _react2.default.createElement(
	        'form',
	        { onSubmit: this.handleSubmit },
	        _react2.default.createElement(
	          'label',
	          null,
	          _react2.default.createElement('input', {
	            type: 'text',
	            className: 'searchbar',
	            value: this.state.value,
	            onChange: this.handleChange,
	            style: { 'margin-right': '4px' },
	            placeholder: 'Search ' + this.props.culture + ' art'
	          })
	        ),
	        _react2.default.createElement('input', { type: 'submit', value: 'Search', name: 'Submit', id: 'frm-submit' })
	      );
	    } else {
	      return null;
	    }
	  };
	
	  return SearchBar;
	}(_react2.default.Component);
	
	exports.default = SearchBar;
	module.exports = exports['default'];

/***/ }),

/***/ 240:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.highlightsPageQuery = undefined;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactHelmet = __webpack_require__(11);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _gatsbyLink = __webpack_require__(8);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _get = __webpack_require__(10);
	
	var _get2 = _interopRequireDefault(_get);
	
	var _rehypeReact = __webpack_require__(33);
	
	var _rehypeReact2 = _interopRequireDefault(_rehypeReact);
	
	var _Mirador = __webpack_require__(45);
	
	var _Mirador2 = _interopRequireDefault(_Mirador);
	
	var _ObjectGrid = __webpack_require__(85);
	
	var _ObjectGrid2 = _interopRequireDefault(_ObjectGrid);
	
	var _SearchBar = __webpack_require__(86);
	
	var _SearchBar2 = _interopRequireDefault(_SearchBar);
	
	var _ToggleTip = __webpack_require__(61);
	
	var _ToggleTip2 = _interopRequireDefault(_ToggleTip);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var HighlightsTemplate = function (_React$Component) {
	  _inherits(HighlightsTemplate, _React$Component);
	
	  function HighlightsTemplate() {
	    _classCallCheck(this, HighlightsTemplate);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  HighlightsTemplate.prototype.render = function render() {
	    var resource = this.props.data.markdownRemark;
	    var siteTitle = (0, _get2.default)(this.props, 'data.site.siteMetadata.title');
	
	    var renderAst = new _rehypeReact2.default({
	      createElement: _react2.default.createElement,
	      components: {
	        'object-grid': _ObjectGrid2.default,
	        'toggle-tip': _ToggleTip2.default,
	        'mirador-viewer': _Mirador2.default
	      }
	    }).Compiler;
	
	    return _react2.default.createElement(
	      'div',
	      { id: 'main' },
	      _react2.default.createElement(_reactHelmet2.default, { title: resource.frontmatter.title + ' | ' + siteTitle }),
	      _react2.default.createElement(
	        'h1',
	        null,
	        resource.frontmatter.title
	      ),
	      _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(_SearchBar2.default, { culture: resource.frontmatter.culture })
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'highlights' },
	        _react2.default.createElement(
	          _react2.default.Fragment,
	          null,
	          renderAst(resource.htmlAst)
	        )
	      )
	    );
	  };
	
	  return HighlightsTemplate;
	}(_react2.default.Component);
	
	exports.default = HighlightsTemplate;
	var highlightsPageQuery = exports.highlightsPageQuery = '** extracted graphql fragment **';

/***/ })

});


// WEBPACK FOOTER //
// component---src-templates-highlights-js-ebc83d57d97d00e180c1.js